const adminStatistics = {
  actions: {
    refresh: 'Refresh',
    retry: 'Retry',
  },
  charts: {
    appRanking: 'App ranking',
    empty: 'No chart data for this time range',
    sessions: 'Sessions',
    uniqueUsers: 'Users',
    usageTrend: 'Usage trend',
    viewAll: 'View all',
  },
  conversationLogs: {
    columns: {
      label: 'Select Dify conversation log columns',
      trigger: 'Columns',
    },
    description:
      'Review message and Workflow run records from the current Dify instance, then export visible fields.',
    dataSource: {
      notConfigured:
        'Dify data source is not configured. Set DIFY_DB_* in the server .env and restart the service.',
      unavailable:
        'Cannot reach the Dify data source. Check network connectivity and database credentials.',
    },
    empty: 'No Dify conversation logs match the current filters',
    error: {
      description: 'Dify conversation logs are temporarily unavailable. Please try again.',
      title: 'Failed to load Dify conversation logs',
    },
    export: {
      csv: 'Export CSV',
      errorEmpty: 'There is no data to export for the current filters.',
      errorGeneric: 'Export failed. Please try again.',
      errorLimit:
        'The export exceeds the 50,000-row limit. Narrow the date range or add more filters.',
      success: 'Exported {{filename}}',
      xlsx: 'Export XLSX',
    },
    fields: {
      answer: 'Answer',
      answer_tokens: 'Answer tokens',
      app_id: 'App ID',
      app_name: 'App name',
      app_mode: 'App type',
      conversation_id: 'Conversation ID',
      conversation_name: 'Conversation title',
      created_at: 'Created at',
      currency: 'Currency',
      end_user_id: 'End-user ID',
      end_user_session_id: 'End-user session ID',
      error: 'Error',
      id: 'Record ID',
      inputs: 'Inputs',
      message_tokens: 'Query tokens',
      model_id: 'Model ID',
      model_provider: 'Model provider',
      outputs: 'Outputs',
      query: 'User query',
      record_key: 'Record key',
      record_type: 'Record type',
      status: 'Status',
      tenant_id: 'Workspace ID',
      tenant_name: 'Workspace',
      total_price: 'Total price',
      total_tokens: 'Total tokens',
      trigger_source: 'Trigger source',
      updated_at: 'Updated at',
    },
    filters: {
      allApps: 'All apps',
      allRecordTypes: 'All record types',
      allWorkspaces: 'All workspaces',
      app: 'App',
      endDate: 'End date',
      keyword: 'Keyword',
      keywordPlaceholder: 'Search titles, queries, IDs, apps, or workspaces...',
      recordType: 'Record type',
      startDate: 'Start date',
      workspace: 'Workspace',
    },
    fullText: {
      title: 'Full content / {{field}}',
    },
    recordTypes: {
      message: 'Message',
      workflow_run: 'Workflow run',
    },
    sort: {
      toggle: 'Sort by {{field}}',
    },
    title: 'Dify conversation logs',
    workflowFallback: {
      default: 'Workflow Run',
      plugin: 'Plugin run',
      schedule: 'Scheduled run',
      webhook: 'Webhook run',
    },
    workspaceLabel: 'Dify conversation logs workspace',
  },
  description: 'Review app usage scale, runtime quality, and app rankings.',
  details: {
    feedback: 'Feedback summary',
    negative: 'Negative feedback',
    overview: 'App overview',
    positive: 'Positive feedback',
    title: 'App details / {{name}}',
    users: 'User details',
  },
  empty: {
    dashboard: 'No usage data for this time range',
    ranking: 'No matching apps',
    users: 'No user details for this time range',
  },
  error: {
    dashboardDescription: 'Usage statistics are temporarily unavailable. Please try again.',
    dashboardTitle: 'Failed to load usage dashboard',
    detailsDescription: 'App usage details are temporarily unavailable.',
    detailsTitle: 'Failed to load app details',
    permissionDescription: 'The current admin account cannot view usage statistics.',
    permissionTitle: 'Usage dashboard access denied',
    rankingDescription: 'The complete app ranking is temporarily unavailable.',
    rankingTitle: 'Failed to load app ranking',
  },
  metrics: {
    avgFirstTokenLatency: 'Avg. first-token latency',
    avgSessionDuration: 'Avg. session duration',
    completedRate: 'Completion rate',
    providerErrorRate: 'Service error rate',
    totalApps: 'Apps',
    totalConversations: 'Conversations',
    totalDuration: 'Total duration',
    totalFeedbacks: 'Feedback',
    totalSessions: 'Sessions',
    totalUsers: 'Users',
    userStopRate: 'User stop rate',
  },
  pagination: {
    next: 'Next page',
    pageSize: '{{size}} per page',
    previous: 'Previous page',
  },
  ranking: {
    searchLabel: 'Search apps',
    searchPlaceholder: 'Search app names...',
    sortByLabel: 'Sort metric',
    sortOrderLabel: 'Sort order',
    title: 'All app rankings',
  },
  sections: {},
  sort: {
    ascending: 'Ascending',
    descending: 'Descending',
    sessions: 'By sessions',
    users: 'By users',
  },
  table: {
    actions: 'Actions',
    app: 'App',
    duration: 'Duration',
    email: 'Email',
    feedback: 'Feedback',
    lastUsedAt: 'Last used',
    sessions: 'Sessions',
    user: 'User',
    users: 'Users',
    viewDetails: 'View details',
  },
  timeRange: {
    custom: 'Custom',
    endDate: 'End date',
    label: 'Time range',
    presets: {
      day: 'Last day',
      last90days: 'Last 90 days',
      month: 'Last 30 days',
      week: 'Last 7 days',
    },
    startDate: 'Start date',
  },
  title: 'App usage dashboard',
  units: {
    milliseconds: '{{value}} ms',
    seconds: '{{value}} sec',
  },
  workspaceLabel: 'App usage dashboard workspace',
}

export default adminStatistics
